<template>
  <b-card no-body>
    <b-card-header>
      <!-- title and subtitle -->
      <div>
        <b-card-title class="mb-1">
          Campaign Daily Budget Usage
        </b-card-title>
        <!-- <b-card-sub-title>Commercial networks</b-card-sub-title> -->
      </div>
      <!--/ title and subtitle -->

      <!-- datepicker -->
      <!-- <div class="d-flex align-items-center">
        <feather-icon
          icon="CalendarIcon"
          size="16"
        />
        <flat-pickr
          v-model="rangePicker"
          :config="{ mode: 'range'}"
          class="form-control flat-picker bg-transparent border-0 shadow-none"
          placeholder="YYYY-MM-DD"
        />
      </div> -->
      <!-- datepicker -->
    </b-card-header>

    <b-card-body>
      <vue-apex-charts
        ref="apex"
        type="area"
        height="300"
        :options="dataCart.chartOptions"
        :series="dataCart.series"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BCardTitle,
//   BCardSubTitle,
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import { mapActions, mapGetters } from 'vuex'
// import flatPickr from 'vue-flatpickr-component'
// import apexChatData from './apexChartData'

export default {
  components: {
    BCard,
    VueApexCharts,
    BCardHeader,
    BCardBody,
    BCardTitle,
    // BCardSubTitle,
    // flatPickr,
  },
  data() {
    return {
      dataCart: {
        series: [
          {
            name: 'Budget Used',
            data: [
              // { x: new Date('2019-03-06').getTime(), y: 1000000 },
            ],
          },
        //   {
        //     name: 'Clicks',
        //     data: [60, 80, 70, 110, 80, 100, 90, 180, 160, 140, 200, 220, 275],
        //   },
        //   {
        //     name: 'Sales',
        //     data: [20, 40, 30, 70, 40, 60, 50, 140, 120, 100, 140, 180, 220],
        //   },
        ],
        chartOptions: {
          chart: {
            toolbar: {
              show: false,
            },
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            show: true,
            width: 2,
            curve: 'straight',
          },
          legend: {
            show: true,
            position: 'top',
            horizontalAlign: 'left',
            fontSize: '14px',
            fontFamily: 'Montserrat',
          },
          markers: {
            size: 5,
            colors: ['#855CF8'],
            strokeColor: '#855CF8',
            strokeWidth: 3,
          },
          grid: {
            xaxis: {
              lines: {
                show: true,
              },
            },
          },
          xaxis: {
            type: 'datetime',
          },
          yaxis: {
            labels: {
              formatter: value => this.convertCurrency(value),
            },
          },
          fill: {
            opacity: 1,
            type: 'solid',
          },
          tooltip: {
            shared: false,
            x: {
              format: 'dd MMM yyyy',
            },
            y: {
              formatter: value => this.convertNomina(value),
            },
          },
          colors: ['rgba(133, 92, 248, .3)'],
        },
      },
      // rangePicker: ['2019-05-01', '2019-05-10'],
    }
  },
  computed: {
    ...mapGetters('campaign', {
      getData: 'getDailyBudget',
    }),
  },
  mounted() {
    this.getCampaignBudget(this.$route.params.id).then(() => {
      this.dataCart.series[0].data = this.setData(this.getData)
      // console.log(this.getData)
      this.$refs.apex.updateSeries(this.dataCart.series)
    })
  },
  methods: {
    ...mapActions('campaign', [
      'getCampaignBudget',
    ]),
    convertCurrency(v) {
      if (typeof v === 'string' || v instanceof String) {
        return v
      }
      if (Math.abs(Number(v)) >= 1.0e+9) return (`${(Math.abs(Number(v)) / 1.0e+9).toFixed(1)}B`).replace('.0', '')
      if (Math.abs(Number(v)) >= 1.0e+6) return (`${(Math.abs(Number(v)) / 1.0e+6).toFixed(1)}M`).replace('.0', '')
      if (Math.abs(Number(v)) >= 1.0e+3) return (`${(Math.abs(Number(v)) / 1.0e+3).toFixed(1)}K`).replace('.0', '')
      return v.toFixed(1).replace('.0', '')
    },
    convertDateChart(str) {
      let dates = str.split('/')
      let strnd = `${dates[2]}-${dates[0]}-${dates[1]}`
      return new Date(strnd).getTime()
    },
    setData(arr) {
      let result = arr.map(e => ({ ...e, x: this.convertDateChart(e.x) }))
      return result
    },
    convertNomina(v) {
      let val = (v / 1).toFixed(0).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
  },
}
</script>
